module.exports = __webpack_public_path__ + "media/images/athletes/1540-f28a01502257e7b47fe73679082ba6c4.png";